<template>
  <div class="reg-modal-container position-relative flex-center">
    <i class="material-icons btn-close unselect" @click="clickCancel">close</i>
    <div v-if="value.package === 'reservation'" style="text-align: center">
      <div class="size-16 weight-500" style="color: #111928">저장되었습니다.</div>
      <div class="size-16 weight-500" style="color: #111928">이제 예약 일정을 등록하세요.</div>
      <button class="button is-primary" @click="clickSettingPrice" style="margin-top: 32px; width: 140px; height:32px !important">예약 일정 설정</button>
    </div>
    <div v-else-if="value.package === 'booking'" style="text-align: center">
      <div class="size-16 weight-500" style="color: #111928">저장되었습니다.</div>
      <div class="size-16 weight-500" style="color: #111928">이제 예약 일정과 가격을 등록하세요.</div>
      <button class="button is-primary" @click="clickSettingPrice" style="margin-top: 32px; width: 140px; height:32px !important">가격/일정 설정</button>
    </div>

    <div v-else style="text-align: center">
      <div class="size-14" style="color: #000">상품이 성공적으로 등록 되었습니다!</div>
      <div class="size-14" style="color: #000">등록된 상품을 확인하시겠습니까?</div>
      <div class="flex-align" style="margin-top: 28px">
        <button class="button is-grey" style="width: 140px;height:38px !important;margin-right:4px" @click="clickList">상품 목록 바로가기</button>
        <button class="button is-primary" @click="clickConfirm" style="width: 140px; height:38px !important;margin-left: 4px">확인하러 가기</button>
      </div>
    </div>
  </div>
</template>

<script>


  export default {
    props: {
      data: {
        type: Object
      }
    },
    components: {
    },
    data() {
      return {
        value: {
          product_id: '',
        },
      }
    },
    created() {
      this.value = this.data;

    },
    watch: {
      data(n) {
        if (n) {
          this.value = n;
        }
      },
    },
    methods: {
      clickCancel() {
        this.$store.commit('cancelModal');
      },
      clickList(){
        this.$store.commit('closeModal');
        if(this.package === 'space') {
          this.$router.replace(this.getPath('space/product'));
        }
        else if(this.getPath(this.$route.path).indexOf('delivery/product/create')>-1) {
          this.$router.replace(this.getPath('delivery/product'));
        }
        else {
          this.$router.replace(this.getPath('product'));
        }
      },
      clickConfirm() {
        this.$store.commit('closeModal');
        const a = document.createElement('a');
        a.href = `${this.$store.getters.brand.domain}/${this.package === 'space' ? 'space_' : ''}product_detail?id=${this.value.product_id}`
        a.target = '_blank';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        a.parentNode.removeChild(a);
        this.$router.replace(`${this.$route.path}?id=${this.value.product_id}`);
      },
      clickSettingPrice() {
        this.$store.commit('prodPackage', this.value.package);
        setTimeout(() => {
          this.$router.replace({
            query: {
              id: this.value.product_id
            }
          })
          this.$store.commit('setProdTab', 1);
        }, 500)
        this.$store.commit('closeModal');
      },
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>
  .reg-modal-container
    background-color #e9e9e9
    border 1px solid #aeaeae
    border-radius 3px
    overflow hidden
    padding 32px 0

  .btn-close
    position absolute
    top 12px
    right 12px
    font-size 20px
    color #777
  .btn-close:hover
    color #ff5722
</style>
